export const textlogin = {
  ingresar: "Ingresa a tu Cuenta",
  acceder: "Para acceder completa la información solicitada",
  tipo: "Tipo de cliente",
  password: "Contraseña",
  olvidado: "¿Olvidaste tu contraseña?",
  doc: "Documento de Identidad",
  registrar: "Registrar Cuenta",
};
export const textSignUp = {
  ingresar: "Registro de Usuario",
  acceder: "Para realizar el registro completa la información solicitada.",
  tipo: "Tipo de cliente",
  volver: "Regresar",
  doc: "Documento de Identidad",
  name: "Nombre y Apellido",
  password: "Contraseña",
  confirmPassword: "Confirmar Contraseña",
  fecha: "Fecha de Nacimiento",
  email: "Correo Electrónico ",
  phone: "Teléfono",
  razon: "Razón Social",
};

export const textRecover = {
  ingresar: "Recuperar Contraseña",
  tipo: "Tipo de cliente",
  email: "Dirección de correo electrónico",
  volver: "Volver",
};
export const textNewPass = {
  ingresar: "Crear Nueva Contraseña",
  tipo: "Tipo de cliente",
  email: "Dirección de correo electrónico",
  volver: "Regresar",
};

export const textSignUpConfirm = {
  confirmar: "¡Buenas noticias! ¡El registro a tu cuenta ha sido exitoso! Ingresa el documento de identificación y la contraseña que elegiste durante el proceso de registro. ¡Gracias!",
};

export const textButtons = {};

export const textInput = {
  1: "Hogar",
  2: "Empresa",
};
